import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6 lg:px-8 bg-gradient-to-b from-white to-[#f7fafc]">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-xs font-semibold text-[#718096] tracking-wider uppercase mb-4">
            COMPREHENSIVE SECURITY &amp; IT SOLUTIONS
          </p>
          <h1 className="text-5xl font-bold text-[#1a2b4a] mb-6">Our Services</h1>
          <p className="text-base text-gray-600 max-w-3xl mx-auto">
            We provide cutting-edge security and IT solutions to enhance connectivity, security, and productivity with the latest technology and professional expertise.
          </p>
        </div>
      </section>

      {/* CCTV Systems Section */}
      <section id="cctv" className="py-20 px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="inline-block bg-[#e6f2ff] text-[#1a2b4a] px-4 py-1 rounded-full text-xs font-semibold mb-4">
                SURVEILLANCE SYSTEMS
              </div>
              <h2 className="text-4xl font-bold text-[#1a2b4a] mb-6">CCTV Systems</h2>
              <p className="text-base text-gray-600 mb-6 leading-relaxed">
                Our advanced CCTV surveillance systems provide comprehensive monitoring and recording capabilities to keep your property secure around the clock. With high-definition cameras and intelligent analytics, you'll have complete visibility and control.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-hd-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">4K Ultra HD Quality</h3>
                    <p className="text-sm text-gray-600">Crystal-clear video recording with exceptional detail for accurate identification and evidence collection.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-cloud-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Cloud &amp; Local Storage</h3>
                    <p className="text-sm text-gray-600">Flexible storage options with secure cloud backup and local recording for redundancy and easy access.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-smartphone-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Remote Monitoring</h3>
                    <p className="text-sm text-gray-600">Access live feeds and recordings from anywhere using your smartphone, tablet, or computer.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-notification-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Smart Alerts</h3>
                    <p className="text-sm text-gray-600">Intelligent motion detection with instant notifications for suspicious activity or security breaches.</p>
                  </div>
                </div>
              </div>

              <Link
                to="/contact#consultation"
                className="inline-block bg-[#1a2b4a] text-white px-8 py-3 rounded-lg text-sm font-medium hover:bg-[#2a3b5a] transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Quote
              </Link>
            </div>
            
            <div className="order-1 lg:order-2">
              <img
                src="https://static.readdy.ai/image/5599338006c54fe6ce07ff64cfd8f48c/b1cb848b5c365c6bc2d17f8c862d4a51.png"
                alt="CCTV Systems"
                className="w-full h-[500px] object-cover rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Access Control Section */}
      <section id="access" className="py-20 px-6 lg:px-8 bg-[#f7fafc]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://static.readdy.ai/image/5599338006c54fe6ce07ff64cfd8f48c/38340406c0181dace4d535ca790cb140.png"
                alt="Access Control Systems"
                className="w-full h-[500px] object-cover rounded-2xl shadow-lg"
              />
            </div>
            
            <div>
              <div className="inline-block bg-[#e6f2ff] text-[#1a2b4a] px-4 py-1 rounded-full text-xs font-semibold mb-4">
                ACCESS MANAGEMENT
              </div>
              <h2 className="text-4xl font-bold text-[#1a2b4a] mb-6">Access Control Systems</h2>
              <p className="text-base text-gray-600 mb-6 leading-relaxed">
                Control who enters your facility with our sophisticated access control systems. From keycard entry to biometric authentication, we provide secure and convenient solutions for managing access to your property.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-fingerprint-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Biometric Authentication</h3>
                    <p className="text-sm text-gray-600">Advanced fingerprint and facial recognition technology for the highest level of security and convenience.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-bank-card-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Keycard Systems</h3>
                    <p className="text-sm text-gray-600">Programmable access cards with customizable permissions for different areas and time schedules.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-user-settings-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Multi-Level Authorization</h3>
                    <p className="text-sm text-gray-600">Create different access levels for employees, visitors, and contractors with granular control.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-file-list-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Detailed Access Logs</h3>
                    <p className="text-sm text-gray-600">Comprehensive reporting and audit trails showing who accessed which areas and when.</p>
                  </div>
                </div>
              </div>

              <Link
                to="/contact#consultation"
                className="inline-block bg-[#1a2b4a] text-white px-8 py-3 rounded-lg text-sm font-medium hover:bg-[#2a3b5a] transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Quote
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Building Security Section */}
      <section id="building" className="py-20 px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="inline-block bg-[#e6f2ff] text-[#1a2b4a] px-4 py-1 rounded-full text-xs font-semibold mb-4">
                COMPLETE PROTECTION
              </div>
              <h2 className="text-4xl font-bold text-[#1a2b4a] mb-6">Building Security</h2>
              <p className="text-base text-gray-600 mb-6 leading-relaxed">
                Comprehensive building security solutions that integrate multiple systems into a unified platform. From perimeter protection to emergency response, we ensure complete safety for your facility and occupants.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-shield-check-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Perimeter Protection</h3>
                    <p className="text-sm text-gray-600">Advanced intrusion detection systems with sensors and barriers to secure your property boundaries.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-alarm-warning-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Fire &amp; Emergency Systems</h3>
                    <p className="text-sm text-gray-600">Integrated fire alarms, emergency lighting, and evacuation systems for rapid response to emergencies.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-dashboard-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Unified Management Platform</h3>
                    <p className="text-sm text-gray-600">Control all security systems from a single interface for streamlined operations and monitoring.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-24-hours-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">24/7 Monitoring</h3>
                    <p className="text-sm text-gray-600">Professional monitoring services with immediate response to security alerts and emergencies.</p>
                  </div>
                </div>
              </div>

              <Link
                to="/contact#consultation"
                className="inline-block bg-[#1a2b4a] text-white px-8 py-3 rounded-lg text-sm font-medium hover:bg-[#2a3b5a] transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Quote
              </Link>
            </div>
            
            <div className="order-1 lg:order-2">
              <img
                src="https://public.readdy.ai/ai/img_res/77875f4ec6b333afd7e64f66ebda1e7f.jpg"
                alt="Building Security"
                className="w-full h-[500px] object-cover rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Network & Security Management Section */}
      <section id="network" className="py-20 px-6 lg:px-8 bg-[#f7fafc]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20network%20server%20room%20with%20organized%20cable%20management%20and%20blue%20LED%20lighting%2C%20modern%20data%20center%20infrastructure%20with%20network%20switches%20and%20routers%2C%20clean%20white%20environment%20with%20advanced%20networking%20equipment%2C%20high-tech%20IT%20infrastructure%20setup%20showing%20connectivity%20and%20security&width=800&height=600&seq=network-security-service&orientation=landscape"
                alt="Network & Security Management"
                className="w-full h-[500px] object-cover rounded-2xl shadow-lg"
              />
            </div>
            
            <div>
              <div className="inline-block bg-[#e6f2ff] text-[#1a2b4a] px-4 py-1 rounded-full text-xs font-semibold mb-4">
                NETWORK SOLUTIONS
              </div>
              <h2 className="text-4xl font-bold text-[#1a2b4a] mb-6">Network &amp; Security Management</h2>
              <p className="text-base text-gray-600 mb-6 leading-relaxed">
                Expert network infrastructure design and management with advanced security protocols. Our network specialists ensure your business stays connected, secure, and running at peak performance.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-router-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Network Infrastructure Design</h3>
                    <p className="text-sm text-gray-600">Custom network architecture tailored to your business needs with scalable and reliable infrastructure.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-shield-keyhole-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Cybersecurity Solutions</h3>
                    <p className="text-sm text-gray-600">Advanced firewall configuration, intrusion detection, and threat prevention to protect your network.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-line-chart-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">24/7 Network Monitoring</h3>
                    <p className="text-sm text-gray-600">Continuous monitoring and proactive maintenance to prevent downtime and ensure optimal performance.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-wifi-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Wireless Network Solutions</h3>
                    <p className="text-sm text-gray-600">Enterprise-grade WiFi systems with seamless coverage and secure guest access management.</p>
                  </div>
                </div>
              </div>

              <Link
                to="/contact#consultation"
                className="inline-block bg-[#1a2b4a] text-white px-8 py-3 rounded-lg text-sm font-medium hover:bg-[#2a3b5a] transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Quote
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Cloud Solutions Section */}
      <section id="cloud" className="py-20 px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="inline-block bg-[#e6f2ff] text-[#1a2b4a] px-4 py-1 rounded-full text-xs font-semibold mb-4">
                CLOUD SERVICES
              </div>
              <h2 className="text-4xl font-bold text-[#1a2b4a] mb-6">Cloud Solutions</h2>
              <p className="text-base text-gray-600 mb-6 leading-relaxed">
                Transform your business with scalable cloud infrastructure. We help you migrate, manage, and optimize your cloud environment for maximum efficiency and cost savings.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-upload-cloud-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Cloud Migration Services</h3>
                    <p className="text-sm text-gray-600">Seamless migration of your applications and data to cloud platforms with minimal disruption.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-settings-3-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Cloud Infrastructure Management</h3>
                    <p className="text-sm text-gray-600">Ongoing management and optimization of your cloud resources for performance and cost efficiency.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-database-2-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Data Backup &amp; Recovery</h3>
                    <p className="text-sm text-gray-600">Automated backup solutions with rapid disaster recovery to protect your critical business data.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-scales-3-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Scalable Solutions</h3>
                    <p className="text-sm text-gray-600">Flexible cloud infrastructure that grows with your business needs and adapts to demand.</p>
                  </div>
                </div>
              </div>

              <Link
                to="/contact#consultation"
                className="inline-block bg-[#1a2b4a] text-white px-8 py-3 rounded-lg text-sm font-medium hover:bg-[#2a3b5a] transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Quote
              </Link>
            </div>
            
            <div className="order-1 lg:order-2">
              <img
                src="https://readdy.ai/api/search-image?query=Stunning%20futuristic%20cloud%20computing%20visualization%20with%20glowing%20neon%20blue%20and%20cyan%20holographic%20cloud%20networks%20floating%20in%20dark%20space%2C%20interconnected%20nodes%20with%20light%20trails%20and%20data%20streams%2C%20dramatic%20lighting%20with%20particle%20effects%2C%20high-tech%20digital%20transformation%20concept%2C%20vibrant%20electric%20blue%20glow%20illuminating%20sleek%20modern%20technology%20infrastructure%2C%20cinematic%20composition%20with%20depth%20and%20energy&width=800&height=600&seq=cloud-solutions-eyecatch&orientation=landscape"
                alt="Cloud Solutions"
                className="w-full h-[500px] object-cover rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* IT Infrastructure Section */}
      <section id="infrastructure" className="py-20 px-6 lg:px-8 bg-[#f7fafc]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20IT%20infrastructure%20setup%20with%20modern%20servers%20and%20network%20equipment%20in%20bright%20office%20environment%2C%20organized%20cable%20management%20and%20clean%20workspace%2C%20digital%20transformation%20concept%20with%20computers%20and%20technology%2C%20white%20and%20blue%20color%20scheme%20showing%20connectivity%20and%20productivity&width=800&height=600&seq=it-infrastructure-service&orientation=landscape"
                alt="IT Infrastructure Optimization"
                className="w-full h-[500px] object-cover rounded-2xl shadow-lg"
              />
            </div>
            
            <div>
              <div className="inline-block bg-[#e6f2ff] text-[#1a2b4a] px-4 py-1 rounded-full text-xs font-semibold mb-4">
                IT OPTIMIZATION
              </div>
              <h2 className="text-4xl font-bold text-[#1a2b4a] mb-6">IT Infrastructure Optimization</h2>
              <p className="text-base text-gray-600 mb-6 leading-relaxed">
                Maximize your IT investment with optimized infrastructure that enhances productivity, enables remote work, and drives digital transformation across your organization.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-speed-up-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Performance Optimization</h3>
                    <p className="text-sm text-gray-600">Analyze and optimize your IT systems for maximum efficiency and reduced operational costs.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-home-wifi-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Remote Working Solutions</h3>
                    <p className="text-sm text-gray-600">Enable secure and productive remote work with VPN, collaboration tools, and cloud access.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-rocket-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">Digital Transformation</h3>
                    <p className="text-sm text-gray-600">Modernize your business processes with cutting-edge technology and automation solutions.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-[#e6f2ff] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-customer-service-2-line text-xl text-[#1a2b4a]"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#1a2b4a] mb-1">IT Support &amp; Maintenance</h3>
                    <p className="text-sm text-gray-600">Comprehensive technical support and proactive maintenance to keep your systems running smoothly.</p>
                  </div>
                </div>
              </div>

              <Link
                to="/contact#consultation"
                className="inline-block bg-[#1a2b4a] text-white px-8 py-3 rounded-lg text-sm font-medium hover:bg-[#2a3b5a] transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Quote
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 px-6 lg:px-8 bg-[#f7fafc]">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-[#1a2b4a] text-center mb-16">Why Choose Our Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#e6f2ff] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-3xl text-[#1a2b4a]"></i>
              </div>
              <h3 className="text-lg font-semibold text-[#1a2b4a] mb-2">Expert Installation</h3>
              <p className="text-sm text-gray-600">Certified technicians with years of experience in security system installation.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-[#e6f2ff] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-line text-3xl text-[#1a2b4a]"></i>
              </div>
              <h3 className="text-lg font-semibold text-[#1a2b4a] mb-2">24/7 Support</h3>
              <p className="text-sm text-gray-600">Round-the-clock technical support and maintenance services for your peace of mind.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-[#e6f2ff] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-price-tag-line text-3xl text-[#1a2b4a]"></i>
              </div>
              <h3 className="text-lg font-semibold text-[#1a2b4a] mb-2">Competitive Pricing</h3>
              <p className="text-sm text-gray-600">Affordable solutions without compromising on quality or reliability.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-[#e6f2ff] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-star-line text-3xl text-[#1a2b4a]"></i>
              </div>
              <h3 className="text-lg font-semibold text-[#1a2b4a] mb-2">Warranty Protection</h3>
              <p className="text-sm text-gray-600">Comprehensive warranty coverage on all equipment and installation work.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-[#1a2b4a] mb-4">
            Ready to Upgrade Your Security?
          </h2>
          <p className="text-base text-gray-600 mb-8">
            Contact us today for a free consultation and custom security solution tailored to your needs.
          </p>
          <Link
            to="/contact#consultation"
            className="inline-block bg-[#1a2b4a] text-white px-8 py-3 rounded-lg text-sm font-medium hover:bg-[#2a3b5a] transition-colors whitespace-nowrap cursor-pointer"
          >
            Schedule Consultation
          </Link>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-[#1a2b4a] mb-4">
            Ready to Transform Your Business?
          </h2>
          <p className="text-base text-gray-600 mb-8">
            Contact us today for a free consultation and discover how our security and IT solutions can enhance your business.
          </p>
          <Link
            to="/contact#consultation"
            className="inline-block bg-[#1a2b4a] text-white px-8 py-3 rounded-lg text-sm font-medium hover:bg-[#2a3b5a] transition-colors whitespace-nowrap cursor-pointer"
          >
            Schedule Consultation
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
